import { render, staticRenderFns } from "./SellerChooserCore.vue?vue&type=template&id=4bd3f5c7&lang=pug&"
import script from "./SellerChooserCore.vue?vue&type=script&lang=js&"
export * from "./SellerChooserCore.vue?vue&type=script&lang=js&"
import style0 from "./SellerChooserCore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports